import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function AdmReq({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Admission Requirements | Bandarban University",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-700 to-teal-700 text-white py-20 text-center">
        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-4xl md:text-6xl font-bold tracking-wide"
        >
          Admission Requirements
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-4 text-lg max-w-3xl mx-auto"
        >
          Explore undergraduate and graduate admission requirements at Bandarban University, Bangladesh.
        </motion.p>
      </section>

      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Bachelor Programs */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-teal-700 mb-6 border-b-4 border-indigo-700 inline-block pb-2">
            Bachelor Programs
          </h2>

          <ul className="list-disc list-inside space-y-2 text-gray-800 ml-4 mb-6">
            <li>Bachelor of Arts in English</li>
            <li>Bachelor of Social Science in Governance and Development Studies (GDS)</li>
            <li>Bachelor of Business Administration (BBA)</li>
            <li>Bachelor of Hospitality and Tourism Management (HTM)</li>
            <li>Bachelor of Computer Science and Engineering (CSE)</li>
          </ul>

          <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-200">
            <h3 className="text-xl font-semibold text-indigo-600 mb-3">Admission Requirements</h3>
            <p className="text-gray-700 leading-relaxed">
              Combined GPA of <span className="font-semibold">5.00</span> in S.S.C and H.S.C with a minimum of <span className="font-semibold">2.5</span> in each, 
              or total GPA of <span className="font-semibold">6.00</span> with minimum GPA of <span className="font-semibold">2.00</span> either in S.S.C or in H.S.C. 
              <br />
              GCE O-Level in minimum <span className="font-semibold">5 subjects</span> with GPA <span className="font-semibold">2.50</span> and GCE A-Level in <span className="font-semibold">2 subjects</span> with a minimum GPA of <span className="font-semibold">2.00</span>. 
              <br />
              Engineering students must have <span className="font-semibold">Mathematics</span> and <span className="font-semibold">Physics</span> in H.S.C with at least <span className="font-semibold">B grade</span>.
            </p>
          </div>
        </motion.div>

        {/* Master Programs */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-teal-700 mb-6 border-b-4 border-indigo-700 inline-block pb-2">
            Master Programs
          </h2>

          <ul className="list-disc list-inside space-y-2 text-gray-800 ml-4 mb-6">
            <li>Master of Business Administration (MBA)</li>
          </ul>

          <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-200">
            <h3 className="text-xl font-semibold text-indigo-600 mb-3">Admission Requirements</h3>
            <p className="text-gray-700 leading-relaxed">
              Anyone having a GPA of minimum <span className="font-semibold">2.50</span> can seek admission to the Master program of the University.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
